var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmalicon = function SvgEmalicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 0A2.25 2.25 0 0 0 .5 2.25v7.5A2.25 2.25 0 0 0 2.75 12h10.5a2.25 2.25 0 0 0 2.25-2.25v-7.5A2.25 2.25 0 0 0 13.25 0H2.75Zm-.374 3a.75.75 0 0 1 1.04-.207L8 5.849l4.584-3.056a.75.75 0 1 1 .832 1.248l-5 3.333a.75.75 0 0 1-.832 0l-5-3.333A.75.75 0 0 1 2.376 3Z",
    fill: "#47516E"
  })));
};
export default SvgEmalicon;